import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import Confirm from "../components/Confirm";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { useForm } from "../helpers/useForm";

export default function CreateEditEvent({ data }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [origin, setOrigin] = useState("");
  const [originArr, setOriginArr] = useState([]);
  const { values, handleValueChange, setValues } = useForm();

  function confirmation(e) {
    e.preventDefault();

    setOpenModal(!openModal);
  }

  useEffect(() => {
    if (id) {
      setValues({
        eventName: data.eventName,
        date: moment(data.date).format("yyyy-MM-DD"),
        startTime: data.startTime,
        endTime: data.endTime,
        origin: data.origin,
      });
      if (data?.origin?.length > 0) setOriginArr(data.origin);
    }
    // eslint-disable-next-line
  }, [id, data]);

  function handleOrigin(index) {
    if (index !== undefined) {
      originArr.splice(index, 1);
    } else {
      if (!origin || originArr.includes(origin)) return;
      originArr.push(origin);
      setOrigin("");
    }

    handleValueChange("", { key: "origin", value: originArr });
  }

  async function submitEvent() {
    const payload = values;
    if (!values.origin) payload.origin = [];

    baseService[id ? "put" : "post"](
      id
        ? config.services.event.editEvent + id
        : config.services.event.createEvent,
      payload,
      () => {
        toast({
          title: `Event ${values.eventName} berhasil ${
            id ? "diedit" : "dibuat"
          }`,
          position: "top",
          status: "success",
          duration: 3000,
          size: "md",
          isClosable: true,
        });
        navigate(-1);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  function handleDelete() {
    baseService.delete(
      config.services.event.deleteEventByID + id,
      () => {
        toast({
          title: `Event ${values.eventName} berhasil dihapus`,
          position: "top",
          status: "success",
          duration: 3000,
          size: "md",
          isClosable: true,
        });
        navigate(-1);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  return (
    <>
      <form onSubmit={confirmation}>
        <Stack
          spacing={4}
          p="1rem"
          backgroundColor="whiteAlpha.900"
          boxShadow="lg"
        >
          <FormControl>
            <FormLabel>Nama Event</FormLabel>
            <Input
              isRequired
              type="text"
              placeholder="Masukkan Nama Event"
              name="eventName"
              defaultValue={values.eventName || ""}
              onChange={handleValueChange}
            />
            {values.eventName === "" && (
              <Text fontSize={13} color="red.500">
                Nama Event wajib diisi.
              </Text>
            )}
          </FormControl>

          <FormControl>
            <FormLabel>Tanggal</FormLabel>
            <Input
              isRequired
              placeholder="Pilih Tanggal dan Waktu"
              size="md"
              type="date"
              name="date"
              defaultValue={values.date || ""}
              onChange={handleValueChange}
            />
            {values.date === "" && (
              <Text fontSize={13} color="red.500">
                Tanggal Event wajib diisi.
              </Text>
            )}
          </FormControl>

          <Flex gap={3}>
            <FormControl>
              <FormLabel>Jam Mulai</FormLabel>
              <Input
                isRequired
                placeholder="Waktu Mulai Event"
                size="md"
                type="time"
                name="startTime"
                defaultValue={values.startTime || ""}
                onChange={handleValueChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Jam Selesai</FormLabel>
              <Input
                isRequired
                placeholder="Waktu Selesai Event"
                size="md"
                type="time"
                name="endTime"
                defaultValue={values.endTime || ""}
                onChange={handleValueChange}
                disabled={!values.startTime}
              />
            </FormControl>
          </Flex>

          <FormControl>
            <FormLabel>Asal Tamu (optional)</FormLabel>
            <Grid gap={2}>
              {originArr.length > 0 &&
                originArr.map((origin, index) => {
                  return (
                    <Flex alignItems="center" key={index}>
                      {id ? (
                        <Input
                          marginRight={2}
                          size="md"
                          defaultValue={origin || ""}
                          onChange={(e) => {
                            originArr.splice(index, 1, e.target.value);
                          }}
                        />
                      ) : (
                        <Input
                          marginRight={2}
                          size="md"
                          disabled={true}
                          value={origin}
                          onChange={(e) => {
                            originArr.splice(index, 1, e.target.value);
                          }}
                        />
                      )}
                      {!id && (
                        <FaMinusCircle
                          color="red"
                          cursor="pointer"
                          onClick={() => handleOrigin(index)}
                        />
                      )}
                    </Flex>
                  );
                })}
              <Flex alignItems="center">
                <Input
                  marginRight={2}
                  placeholder="Tentukan Asal Tamu"
                  size="md"
                  type="text"
                  name="origin"
                  value={origin || ""}
                  onChange={(e) => setOrigin(e.target.value)}
                />
                <FaPlusCircle
                  color="blue"
                  cursor="pointer"
                  onClick={() => handleOrigin()}
                />
              </Flex>
            </Grid>
          </FormControl>
        </Stack>

        <Flex justifyContent="end">
          <Button mt={6} mr={3} onClick={() => navigate(-1)} colorScheme="gray">
            Batal
          </Button>
          <Button mt={6} mr={3} type="submit" colorScheme="blue">
            {id ? "Simpan" : "Daftar"}
          </Button>
          {id && (
            <Button
              mt={6}
              onClick={() => setOpenModalDelete(!openModalDelete)}
              colorScheme="red"
            >
              Hapus
            </Button>
          )}
        </Flex>
      </form>
      <Confirm
        content={{
          title: "Konfirmasi",
          desc: `Apakah anda yakin untuk ${id ? "edit" : "membuat"} event ${
            values.eventName
          }?`,
        }}
        active={openModal}
        onCancel={() => setOpenModal(!openModal)}
        callback={submitEvent}
      />
      <Confirm
        content={{
          title: "Konfirmasi",
          desc: `Apakah anda yakin untuk hapus event ${values.eventName}?`,
        }}
        active={openModalDelete}
        onCancel={() => setOpenModalDelete(!openModalDelete)}
        callback={handleDelete}
      />
    </>
  );
}
